
document.addEventListener("DOMContentLoaded", function () {

  const popup = document.querySelector(".gwp-popup");
  const addBtn = document.querySelector(".popup_add_to_cart");
  const closeBtn = document.querySelector(".fp-header .icon-close");
  const cancelBtn = document.querySelector(".fp-footer .cn");


const isGwpEnabled = window.gwp?.settings?.enable_gwp_offer;

if (!isGwpEnabled) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const gwpItems = cart.items.filter(item =>
        item.properties && item.properties._gwp_product
      );

      if (gwpItems.length === 0) return;

      // Remove all GWP products
      const updates = {};

      gwpItems.forEach(item => {
        updates[item.key] = 0; // set quantity to 0 = remove
      });

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    })
    .then(() => {
      console.log('GWP items removed because offer disabled.');
    })
    .catch(err => console.error('Error removing GWP items:', err));
}


  if (!popup || !window.gwp?.settings?.enable_gwp_offer) return;

  /* ===============================
      CART HELPERS
  =============================== */

  async function getCart() {
    const res = await fetch("/cart.js");
    return await res.json();
  }

  function cartHasGwp(cart) {
    return cart.items.some(item =>
      item.properties && item.properties._gwp_product
    );
  }

  function getNonGwpTotal(cart) {
    return cart.items
      .filter(item => !item.properties?._gwp_product)
      .reduce((total, item) => total + item.final_line_price, 0);
  }

  function hasNormalProducts(cart) {
    return cart.items.some(item => !item.properties?._gwp_product);
  }

 

  /* ===============================
      POPUP CONTROL
  =============================== */

  function showPopup() {
    window.dispatchEvent(new Event('theme:scroll:unlock'));
    window.theme.state.cartOpen = false;
    popup.classList.add("popup-show");
  }

  function hidePopup() {
    popup.classList.remove("popup-show");
  }
/* ===============================
   CART EMPTY UI HANDLER
================================ */

function handleCartEmptyState(cart) {
  const cartForm = document.querySelector('[data-cart-form]');
  const cartEmpty = document.querySelector('[data-cart-empty]');
  const promoBar = document.querySelector('.promo-bar-section');
  const CartBottom = document.querySelector('[data-cart-bottom]');
  const isEmpty = cart.item_count == 0;

  if (cartForm && cartEmpty) {
    cartForm.classList.toggle('cart--hidden', isEmpty);
     CartBottom.classList.toggle('cart--hidden', isEmpty);
    cartEmpty.classList.toggle('cart--hidden', !isEmpty);
  }

  if (promoBar) {
    promoBar.classList.toggle('hide', isEmpty);
  }
}
  /* ===============================
      THRESHOLD CHECK
  =============================== */

  async function checkThreshold(passedCart = null) {

    const cart = passedCart || await getCart();
       setTimeout(() => {
     handleCartEmptyState(cart);
}, 1000);
     
    const threshold = Number(gwp.settings.gwp_thresold || 0);

    const nonGwpTotal = getNonGwpTotal(cart);
    const hasGwp = cartHasGwp(cart);
    const hasNormal = hasNormalProducts(cart);
    const eligible = nonGwpTotal >= threshold;
const promoBefore = document.querySelector(".promobar-before");
    const promoAfter = document.querySelector(".promobar-after");
        if (promoBefore && promoAfter) {
      if (hasGwp) {
        promoBefore.classList.add("hide");
        promoAfter.classList.remove("hide");
      } else {
        promoBefore.classList.remove("hide");
        promoAfter.classList.add("hide");
      }
    }
    /* ===============================
       HANDLE GWP CART PRODUCT VISIBILITY
    =============================== */
const gwpCartProduct = document.querySelector(".gwp-cart-product");

if (gwpCartProduct) {
  const shouldShow = nonGwpTotal >= threshold && !hasGwp;
  gwpCartProduct.classList.toggle("hide", !shouldShow);
}
  

    /* ===============================
       POPUP + AUTO REMOVAL LOGIC
    =============================== */

    if (!hasNormal) {
      hidePopup();
      if (hasGwp) await removeGwp(cart);
      return;
    }

    if (!eligible) {
      hidePopup();
      if (hasGwp) await removeGwp(cart);
      return;
    }

    if (!hasGwp) {
      showPopup();
    } else {
      hidePopup();
    }
  }
 /* ===============================
      REMOVE GWP
  =============================== */

  async function removeGwp(cart) {

    const gwpItem = cart.items.find(item =>
      item.properties && item.properties._gwp_product
    );

    if (!gwpItem) return;

    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: gwpItem.key,
        quantity: 0
      })
    });

    document.dispatchEvent(new CustomEvent('theme:cart:reload', {
      bubbles: true
    }));
    checkThreshold();

  }
  /* ===============================
      ADD GWP PRODUCT
  =============================== */

  async function addGwpProduct() {

    const selectedRadio = document.querySelector('input[name="GWP"]:checked');
    if (!selectedRadio) return;

    const container = selectedRadio.closest(".free-product");
    if (!container) return;

    let variantId;

    const select = container.querySelector("select");
    if (select) {
      variantId = select.value;
    } else {
      const hiddenInput = container.querySelector('input[type="hidden"]');
      if (hiddenInput) variantId = hiddenInput.value;
    }

    if (!variantId) return;

    /* 🔥 Loading state */
    addBtn.classList.add("loading");
    addBtn.disabled = true;

    try {

      const cart = await getCart();

      if (cartHasGwp(cart)) {
        hidePopup();
        return;
      }

      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            _gwp_product: true
          }
        })
      });

      document.dispatchEvent(new CustomEvent('theme:cart:reload', {
        bubbles: true
      }));

      hidePopup();
checkThreshold();
    } catch (error) {
      console.error("GWP Add Error:", error);
    } finally {
      addBtn.classList.remove("loading");
      addBtn.disabled = false;
    }
  }

  /* ===============================
      EVENTS
  =============================== */

  if (addBtn) {
    addBtn.addEventListener("click", function (e) {
      e.preventDefault();
      addGwpProduct();
    });
  }

  if (closeBtn) closeBtn.addEventListener("click", hidePopup);
  if (cancelBtn) cancelBtn.addEventListener("click", hidePopup);

  document.addEventListener("theme:cart:change", function (event) {
    checkThreshold(event.detail.cart);
  });

  /* Initial check */
  checkThreshold();

});
